@if(userLoggedIn()) {

<div class="bg-dark">
  <div class="mt-2">
    <button
      [matMenuTriggerFor]="userDashboard"
      class="mx-2"
      ngClass="lolaHeaderButton__desktop"
      ngClass.lt-sm="lolaHeaderButton__mobile"
      aria-label="abrir menu"
    >
      <lib-shared-ui-profile-avatar
        [userName]="user?.displayName"
        [userPhoto]="user?.photoURL"
      >
      </lib-shared-ui-profile-avatar>
    </button>
  </div>
</div>
} @else {
<button
  mat-raised-button
  color="primary"
  routerLink="/login"
  aria-label="iniciar sesión"
  i18n
>
  INICIAR SESIÓN
</button>
}

<mat-menu #userDashboard="matMenu" class="toolbar-mat-menu">
  <div class="my-4 mx-4 row-container left">
    <lib-shared-ui-profile-avatar
      [userName]="user?.displayName"
      [userPhoto]="user?.photoURL"
    >
    </lib-shared-ui-profile-avatar>
    <div
      *ngIf="user?.email; else showLoginButton"
      class="ml-2 column-container left"
    >
      <span class="mat-body-1">{{ user?.displayName ?? '' }}</span>
      <span class="mat-body-1">{{ user?.email ?? '' }}</span>
    </div>
    <ng-template #showLoginButton>
      <button
        mat-button
        color="primary"
        routerLink="/login"
        aria-label="iniciar sesión"
        i18n
      >
        INICIAR SESIÓN
      </button>
    </ng-template>
  </div>
  <button
    *ngIf="user?.email"
    mat-menu-item
    class="w-100"
    routerLink="dashboard/profile"
    aria-label="ver perfil"
  >
    <mat-icon color="primary">person</mat-icon>
    <span class="mat-body-1">Ver perfil</span>
  </button>
  <button
    *ngIf="user?.email"
    mat-menu-item
    class="w-100"
    routerLink="dashboard"
    aria-label="ir al dashboard"
  >
    <mat-icon color="primary">analytics</mat-icon>
    <span class="mat-body-1">Ver dashboard</span>
  </button>
  <!-- TODO -->
  <!-- *** DARK MODE TOGGLE *** -->
  <!-- <div class="w-100 ml-4 align-center">
    <mat-icon color="primary" *ngIf="darkMode">bedtime</mat-icon>
    <mat-icon color="primary" *ngIf="!darkMode">brightness_5</mat-icon>
    <mat-slide-toggle
      color="primary"
      [(ngModel)]="darkMode"
      (change)="darkModeChange.emit(darkMode)"
      class="mx-2"
    >
    </mat-slide-toggle>
  </div> -->
  <button
    *ngIf="user?.email"
    mat-menu-item
    class="w-100"
    (click)="logout.emit()"
    aria-label="cerrar sesión"
  >
    <mat-icon color="warn">logout</mat-icon>
    <span>Cerrar sesión</span>
  </button>
</mat-menu>
